/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveCatalogItem200Response
 */
export interface RemoveCatalogItem200Response {
    /**
     * 
     * @type {string}
     * @memberof RemoveCatalogItem200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the RemoveCatalogItem200Response interface.
 */
export function instanceOfRemoveCatalogItem200Response(value: object): value is RemoveCatalogItem200Response {
    return true;
}

export function RemoveCatalogItem200ResponseFromJSON(json: any): RemoveCatalogItem200Response {
    return RemoveCatalogItem200ResponseFromJSONTyped(json, false);
}

export function RemoveCatalogItem200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveCatalogItem200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function RemoveCatalogItem200ResponseToJSON(value?: RemoveCatalogItem200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
    };
}

